/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from "utils/styles/style_helpers";



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : MY PROFILE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme =>({
    myprofile:{
        '& .name-page-copy': {
            opacity: '0',
            animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
        },
        '& .name-page-details': {
            opacity: '0',
            animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.175s',
        },

        // forms
        '& .form': {
            '& .griditem':{
                '& .text':{
                    width: pxToEm(200),
                    color: theme.color.primary.medium.swatch
                },
                '&.name-change-password': {
                    paddingTop: pxToEm(35)
                }
            }
        }
    }
})